import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "../../../services/common/common.service";
import { DataTableDirective } from "angular-datatables";
import { Observable } from "rxjs";
import Swal from "sweetalert2";
import { environment } from "../../../../environment/environment";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { DomSanitizer } from "@angular/platform-browser";
import { HttpEvent, HttpHeaders, HttpResponse } from "@angular/common/http";
@Component({
  selector: "app-complaints-create",
  templateUrl: "./complaints-create.component.html",
  styleUrls: ["./complaints-create.component.css"],
})
export class ComplaintsCreateComponent {
  // Editor = require("src/assets/ckeditor/ckeditor.js"); // Point to local CKEditor
  // complaintDescription: string = "";

  employeeList = [];
  soList: any;
  editorConfig: any;
  users: any;
  customer_id: any;
  id: any;
  project_no: any;
  customerName: any;
  priceValidityTill: any;
  project_head: any;
  org_id: any;

  proposalFrm: any = [];
  submitted: any;
  customerActionLogsId: any;
  url: any;
  selectedImages: string[] = [];
  selectedImagesArray: any;
  errorMessage: string = "";

  fromDashboard: boolean = false;

  editorConfigNew: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "300px",
    minHeight: "200px",
    maxHeight: "auto",
    width: "auto",
    minWidth: "0",
    translate: "yes",
    enableToolbar: true,
    showToolbar: true,
    placeholder: "Enter text here...",
    defaultParagraphSeparator: "",
    defaultFontName: "",
    defaultFontSize: "",
    fonts: [
      { class: "arial", name: "Arial" },
      { class: "times-new-roman", name: "Times New Roman" },
      { class: "calibri", name: "Calibri" },
      { class: "comic-sans-ms", name: "Comic Sans MS" },
    ],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
    upload: (file: File) => this.handleImageUpload(file),
    sanitize: true,
  };

  handleImageUpload(file: File): Observable<HttpEvent<any>> {
    return new Observable((observer) => {
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64Image = reader.result as string;
          // Create the response object with empty headers
          const response = new HttpResponse({
            body: { imageUrl: base64Image },
            status: 200,
            statusText: "OK",
            headers: new HttpHeaders(), // Use empty HttpHeaders
            url: "",
          });

          observer.next(response); // Emit the response as an HttpEvent
          observer.complete(); // Complete the observable
        };
        reader.onerror = (error) => {
          observer.error(error); // Emit an error if file reading fails
        };
        reader.readAsDataURL(file); // Read file as base64
      } else {
        observer.error("No file selected"); // Emit an error if no file is selected
      }
    });
  }

  // emailExtension : string ="@grindmaster.co.in";
  constructor(
    private CommonService: CommonService,
    private route: ActivatedRoute,

    private router: Router,
    private _formBuilder: FormBuilder,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    //if came here from dashboard
    this.route.queryParams.subscribe((params) => {
      this.fromDashboard = params["fromDashboard"] === "true"; // Convert string to boolean
      console.log("From Dashboard:", this.fromDashboard);
    });

    if (localStorage.getItem("customerId") == null) {
      this.router.navigate(["/login"]);
    }
    this.customerActionLogsId = localStorage.getItem("customerActionLogsId");
    this.org_id = localStorage.getItem("org_id");
    this.editorConfig = {
      versionCheck: false,
      //custom font css file
      // contentsCss: "./assets/fonts/fonts.css",
      //custom font names
      font_names:
        "Sofia-Pro-Medium-Az;" +
        "Sofia-Pro-Black-Az;" +
        "Sofia-Pro-Black-Italic-Az;" +
        "Sofia-Pro-Bold-Az;" +
        "Sofia-Pro-Bold-Italic-Az;" +
        "Sofia-Pro-ExtraLight-Az;" +
        "Sofia-Pro-Light-Az;" +
        "Sofia-Pro-Light-Italic-Az;" +
        "Sofia-Pro-Medium-Italic-Az;" +
        "Sofia-Pro-Regular-Az;" +
        "Sofia-Pro-Regular-Italic-Az;" +
        "Sofia-Pro-Semi-Bold-Az;" +
        "Sofia-Pro-Semi-Bold-Italic-Az;" +
        "sofiapro-light;",
    };
    this.route.params.subscribe((params) => {
      this.id = params["id"];
      this.customer_id = localStorage.getItem("customerId");
      // const payload ={
      //     "customerId": this.customer_id
      // }
      const payload = {
        modelName: "department",
        whereCondition: {
          client_id: this.customer_id,
          inactive: 1,
        },
        pagination: {
          pageSize: 10000,
          page: 1,
        },
      };
      this.CommonService.getRecords(payload).subscribe((e: any) => {
        this.soList = e.data;
        // this.project_head = this.soList.head;
        console.log("this.soList---", this.soList);
      });
    });
    this.proposalFrm = this.createCountryForm();
    this.proposalFrm.controls["customerId"].setValue(this.customer_id);
  }

  createCountryForm() {
    return (this.proposalFrm = this._formBuilder.group({
      customerId: [""],
      subject: ["", Validators.required],
      soNumber: ["", Validators.required],
      email: [
        "",
        [
          Validators.required,
          Validators.pattern(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          ),
        ],
      ],
      complaintDetails: ["", Validators.required],
      selectedImages: [this.selectedImages],
      selectedImagesArray: [this.selectedImagesArray],
    }));
  }

  selectProjectHead(event: Event): void {
    const selectedId = (event.target as HTMLSelectElement).value;
    const selectedSo = this.soList.find(
      (so: any) => so.id.toString() === selectedId
    );
    if (selectedSo) {
      this.project_head = selectedSo.head;
    }
  }

  onSubmit() {
    this.submitted = true; // Mark form as submitted
    const sanitizedComplaintDetails = this.sanitizer.sanitize(
      1, // Safe value level 1 (HTML content)
      this.proposalFrm.value.complaintDetails
    );
    // Merge selectedImages with form data
    // const formData = {
    //   ...this.proposalFrm.value,
    //   complaintDetails: sanitizedComplaintDetails,
    //   selectedImages: this.selectedImages,
    //   selectedImagesArray: this.selectedImagesArray,
    //   customerActionLogsId: this.customerActionLogsId,
    //   project_head: this.project_head,
    //   organization_id: this.org_id,
    // };

      //  Stop submission if there's a file error
      if (this.errorMessage) {
        return;
      }

    // Check if the form is invalid
    if (this.proposalFrm.invalid) {
      // Swal.fire("Warning!", "Please fill required data.", "warning");
      // this.submitted = false; // Reset the submitted flag
      return;
    }


    //multer
    const formData = new FormData();
    formData.append('customerId', this.proposalFrm.value.customerId);
    formData.append('soNumber', this.proposalFrm.value.soNumber);
    formData.append('subject',this.proposalFrm.value.subject);
    formData.append('complaintDetails', sanitizedComplaintDetails || '');
    formData.append('email', this.proposalFrm.value.email);
    formData.append('project_head', this.project_head || 0);
    formData.append('organization_id', this.org_id || 0);
    formData.append('customerActionLogsId', this.customerActionLogsId || '');
    if (Array.isArray(this.selectedImagesArray) && this.selectedImagesArray.length > 0) {
      this.selectedImagesArray.forEach((file:any, index:any) => {
        formData.append('attachments', file); // Multer will collect all "attachments"
      });
    }
    //multer end

    // console.log("Form Data Submitted:", formData);
    // return;
    // Call the service to create customer complaints
    this.CommonService.createCustomerComplaints(formData).subscribe(
      (response: any) => {
        this.submitted = false; // Reset the submitted flag

        if (response.code == 1) {
          // Success response
          Swal.fire({
            title: "Success",
            text: "Service Call / Complaint Created Successfully.",
            icon: "success",
            showConfirmButton: true,
            allowOutsideClick: false, // Prevent closing by clicking outside
            allowEscapeKey: false, // Prevent closing with the Escap
          }).then((result) => {
            if (result.isConfirmed) {
              // Navigate to the complaints list
              this.router
                .navigateByUrl("/app/refresh", { skipLocationChange: true })
                .then(() => {
                  this.router.navigate(["/ComplaintsList"]);
                });
            }
          });
        } else if (response.code == 0) {
          if (response?.data == "email") {
            this.submitted = true;
            // this.proposalFrm
            //   .get("email")
            //   .setErrors({ serverError: response.message }); //Rajesh - will remove in next commit

            const emailControl = this.proposalFrm.get('email');
            emailControl.setErrors({ serverError: response.message });
            emailControl.markAsTouched({ onlySelf: true });
            emailControl.markAsDirty({ onlySelf: true });           

          } else {
            // Warning response
            Swal.fire({
              title: "Warning!",
              text: response.message,
              icon: "warning",
              timer: 3000,
            });
          }
        } else {
          // Unexpected error
          Swal.fire({
            title: "Warning!",
            text: "Something went wrong.",
            icon: "warning",
            timer: 3000,
          });
        }
      },
      (error) => {
        console.error("Service call failed:", error);
        this.submitted = false; // Reset the submitted flag in case of failure
        Swal.fire(
          "Error",
          "Failed to submit the form. Please try again.",
          "error"
        );
      }
    );
  }

  goBack() {
    if (this.fromDashboard) {
      this.router.navigate(["/dash"]);
    } else {
      this.router.navigate(["/ComplaintsList"]);
    }
  }

  // image code
  onImageSelectold(event: any): void {
    const files: FileList = event.target.files;
    this.selectedImages = []; // Will contain base64 data
    this.selectedImagesArray = []; // Will contain file objects with filenames
    this.errorMessage = ""; // For error messages

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      // Validate the file type
      if (!file.type.startsWith("image/")) {
        this.errorMessage = "Only image files are allowed.";
        continue;
      }

      const reader = new FileReader();

      reader.onload = (e: any) => {
        // Push the base64 encoded image data to the selectedImages array
        this.selectedImages.push(e.target.result);
      };

      reader.readAsDataURL(file);

      // Push the file object with filename to the selectedImagesArray
      this.selectedImagesArray.push({
        file: file,
        filename: file.name,
      });
    }

    // If no valid files were selected, clear the arrays
    if (this.selectedImages.length === 0 && this.errorMessage) {
      event.target.value = ""; // Reset the input field
    }
  }
  // Rajesh - will remove in next commit
  // onImageSelect(event: any): void {
  //   const files: FileList = event.target.files;
  //   this.selectedImages = []; // Base64 strings
  //   this.selectedImagesArray = []; // Files with names
  //   this.errorMessage = "";
  
  //   for (let i = 0; i < files.length; i++) {
  //     const file = files[i];
  
  //     // Accept only images and PDFs
  //     const isImage = file.type.startsWith("image/");
  //     const isPdf = file.type === "application/pdf";
  
  //     if (!isImage && !isPdf) {
  //       this.errorMessage = "Only image or PDF files are allowed.";
  //       continue;
  //     }
  
  //     const reader = new FileReader();
  
  //     reader.onload = (e: any) => {
  //       this.selectedImages.push(e.target.result);
  //     };
  
  //     reader.readAsDataURL(file); // Works for both image and PDF
  
  //     this.selectedImagesArray.push({
  //       file: file,
  //       filename: file.name,
  //     });
  //   }
  
  //   if (this.selectedImages.length === 0 && this.errorMessage) {
  //     event.target.value = "";
  //   }
  // }
  
  //new - not in use for now
  onImageSelectNEW(event: any): void {
    const files: FileList = event.target.files;
    this.selectedImages = []; // Base64 strings
    this.selectedImagesArray = []; // Files with names
    this.errorMessage = "";
  
    // 
    const MAX_SIZE = 5 * 1024 * 1024; // 5MB
  //
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
  
      // Accept only images and PDFs
      const isImage = file.type.startsWith("image/");
      const isPdf = file.type === "application/pdf";
  
      if (!isImage && !isPdf) {
        this.errorMessage = "Only image or PDF files are allowed.";
        continue;
      }
      //
      if (file.size > MAX_SIZE) {
        this.errorMessage = `"${file.name}" exceeds the 5MB limit.`;
        continue;
      }
      // 
  
      const reader = new FileReader();
  
      reader.onload = (e: any) => {
        const result = e.target.result;

        if (!result.startsWith("data:image/") && !result.startsWith("data:application/pdf")) {
          this.errorMessage = `"${file.name}" is not a supported file format.`;
          return;
        }
  
        this.selectedImages.push(result);
        this.selectedImagesArray.push({
          file: file,
          filename: file.name,
        });
      };
  
      reader.readAsDataURL(file); // Works for both image and PDF
  
      // this.selectedImagesArray.push({
      //   file: file,
      //   filename: file.name,
      // });
    }
  
    if (this.selectedImages.length === 0 && this.errorMessage) {
      event.target.value = "";
    }
  }

  //Rajesh - multer handling
  onImageSelect(event: any): void {
    const maxSizeInBytes = 5 * 1024 * 1024; // 10 MB
    const files: FileList = event.target.files;
    this.selectedImagesArray = [];
    this.errorMessage = "";
  
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const isImage = file.type.startsWith("image/");
      const isPdf = file.type === "application/pdf";
  
      if (!isImage && !isPdf) {
        this.errorMessage = "Only image or PDF files are allowed.";
        continue;
      }
      if (file.size > maxSizeInBytes) {
        this.errorMessage = `File "${file.name}" exceeds the 5MB size limit.`;
        continue;
      }
  
      this.selectedImagesArray.push(file);
    }
  }
}
